(ns superadmin.os-workspace-editor.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [common.modal.view :refer [confirmation-modal defmodal]]
            [common.queries :refer [use-query]]
            [common.widgets.data-grid :as dg]
            [common.widgets.page :as page]
            [re-frame.core :as rf]
            [superadmin.os-workspace-editor.create-ocp.view]
            [superadmin.os-workspace-editor.db]
            [superadmin.resource.workspace :as workspace.q]
            [uix.core :as uix :refer [$ defui]]))

(defmodal confirm-delete ::confirm-delete
  [{:keys [delete-fn]}]
  ($ confirmation-modal {:title "Delete workspace mapping"
                         :confirm-details "The mapping will be deleted, making related campaigns in WPP projects inaccessible."
                         :action-fn delete-fn}))

(def ^:private columns
  #js [#js {:field "workspace-id"
            :headerName "Workspace ID"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:workspace-id row))
            :flex 2}
       #js {:field "agency-id"
            :headerName "Agency ID"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:agency-id row))
            :flex 1}
       #js {:field "advertiser-id"
            :headerName "Advertiser ID"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:advertiser-id row))
            :flex 1}
       #js {:field "comment"
            :headerName "Comment"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:comment row))
            :flex 1}
       #js {:field "actions"
            :type "actions"
            :getActions (fn [^js params]
                          #js [($ GridActionsCellItem
                                  {:onClick #(rf/dispatch
                                              [:modal/open {:id ::confirm-delete
                                                            :props {:delete-fn (fn []
                                                                                 (rf/dispatch [:os-workspace-editor/delete-mapping (.-row params)]))}}])
                                   :icon ($ Icon "delete")})])}])

(def Toolbar
  (uix/as-react
   (fn []
     ($ dg/grid-toolbar
        {:hide-quick-filter true
         :sx #js {:justifyContent "flex-end"}}
        ($ Button
           {:onClick #(rf/dispatch [:ocp/open {:id :os-workspace-mapping/create}])
            :data-test-id :create-os-workspace-mapping-button
            :startIcon ($ Plus)
            :variant "contained"}
           "New mapping")))))

(defn- get-row-id [row]
  (:workspace-id row))

(defui workspace-mappings-datagrid []
  (let [{:keys [data isPending]} (use-query (workspace.q/workspace-mappings-query))]
    ($ DataGridPremium
       {:columns columns
        :loading isPending

        :rows (to-array data)
        :getRowId get-row-id

        :disableRowSelectionOnClick true

        :pagination true
        :pageSizeOptions #js [10]

        :slots #js {:toolbar Toolbar}

        :data-testid "table-os-workspace-mappings"

        :noWrap true
        :sx #js {:maxHeight "70rem"}})))

(defui os-workspaces-page []
  ($ page/page
     ($ page/page-header {:title "OS Workspace Mappings"})
     ($ page/content-padding {:sx #js {:overflow "hidden"}}
        ($ workspace-mappings-datagrid))))
